import { IVisitsService } from "./VisitsService";
import { IBookingService } from "./BookingService";
import { IService as ICateringMenuItemService } from "./CateringMenuItems/Service";
import { IService as IRoleService } from "./Roles/Service";
import { IUserPreferencesService } from "./UserPreferencesService";

export class Services implements IServices
{
    public bookings: IBookingService;
    public visits: IVisitsService;
    public userPreferences: IUserPreferencesService;
    public cateringMenuItems: ICateringMenuItemService;
    public roles: IRoleService;

    constructor(
        bookings: IBookingService,
        visits: IVisitsService,
        userPreferences: IUserPreferencesService,
        cateringMenuItems: ICateringMenuItemService,
        roles: IRoleService,
    )
    {
        this.bookings = bookings;
        this.visits = visits;
        this.userPreferences = userPreferences;
        this.cateringMenuItems = cateringMenuItems;
        this.roles = roles;
    }
}

export interface IServices
{
    bookings: IBookingService;
    visits: IVisitsService;
    userPreferences: IUserPreferencesService;
    cateringMenuItems: ICateringMenuItemService;
    roles: IRoleService;
}
